<div *ngIf="item && fields">

  <app-lagreknapp [formGroup]="formGroup" (onLagre)="lagre()" [isSaving]="isSaving" ></app-lagreknapp>

  <app-feltkolonner [formGroup]="formGroup" [textAreaCol]="textAreaCol" [col1]="col1" [col2]="col2" [checkboxCol]="checkboxCol" [model]="item"></app-feltkolonner>

<app-tabs [tabs]="tabs" ></app-tabs>

</div>
